var _defs, _path, _path2, _rect, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathDownhill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cykel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 369.5 369.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #00672f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.5,184.75c0,102.04-82.72,184.75-184.75,184.75S0,286.79,0,184.75,82.72,0,184.75,0s184.75,82.72,184.75,184.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.49,53.7c.7,4.43-2.31,8.58-6.74,9.29-4.42.7-8.58-2.31-9.28-6.73-.71-4.42,2.31-8.58,6.73-9.29,4.42-.71,8.58,2.31,9.29,6.73"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 176.3,
    y: 28.61,
    width: 5.4,
    height: 33.28
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.96,146.24c-11.23,3.67-23.35-2.49-27.02-13.72-3.66-11.23,2.49-23.35,13.72-27.02,11.23-3.67,23.35,2.49,27.02,13.72,3.67,11.23-2.49,23.35-13.72,27.02h0ZM177.34,110.65c-8.4,2.74-13,11.8-10.26,20.2,2.74,8.4,11.8,13,20.2,10.26s13-11.8,10.26-20.2c-2.74-8.4-11.8-12.99-20.2-10.25h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.46,74.26c-7.48-9.76-21.5-11.62-31.27-4.14-1.44,1.11-2.69,2.37-3.78,3.72l-.09-.06-11.54-7.37h0s-5.59-3.51-5.59-3.51l-13.3,5.29-16.06-.84-5.11,2.22-.83,7.07-6.06,2.13,23.48,22.4,15.17-8.99,4.65,12.26,9.81,2.04-11.12-29.67-15.81,2.17-2.7-4.71,5.25-.35,14.34-5.42,13.4,8.3.05.03c-4.25,7.55-3.89,17.23,1.71,24.53,7.48,9.76,21.5,11.62,31.27,4.14,9.76-7.48,11.62-21.5,4.14-31.27h0ZM238.86,101.03c-7.28,5.58-17.74,4.19-23.31-3.09-4.1-5.35-4.42-12.41-1.42-17.99l.76.49s0-.02.01-.03l13.34,8.52,1.96-3.08-13.28-8.48-.72-.46c.72-.83,1.53-1.6,2.44-2.29,7.28-5.58,17.74-4.19,23.32,3.09,5.58,7.28,4.19,17.74-3.09,23.32h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathDownhill);
export default __webpack_public_path__ + "static/media/path-downhill.19a689fc.svg";
export { ForwardRef as ReactComponent };